/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import { toast } from 'react-toastify';
import clsx from "clsx";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { ListTable } from './ListTable.js';
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { NavLink } from "react-router-dom";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const ComponentType = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { componentDetails, loader } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [visible, setVisible] = useState(false);
    const [errorComponentType, setErrorComponentType] = useState(false);

    const { history } = props;

    const [addMore, setAddMore] = useState(false);
    const [componentId, setComponentId] = useState(false);
    const [componentType, setComponentType] = useState('');

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [deleteModal, setDeleteModal] = useState(false);
    const [importVisible, setImportVisible] = useState(false);


    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);

    const dispatch = useDispatch();

    const [form, setForm] = useState({
        componentType: "",
        description: ""
    });

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");



    const classes = customStyles();

    const handleOpen = () => {
        setVisible(true);
        emptyStateInput();
        emptyState();
    };
    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };

    const changeHandler = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Component Type', history, 'Younote Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ componentType: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'component-types',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            },
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);


    const createComponent = (e) => {
        e.preventDefault();
        let emptyComponentType = emptyValidation('componentType', form.componentType);
        if (emptyComponentType.isValid) {
            delete form.percentage;
            dispatch({
                type: componentId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'component-types',
                title: 'Component Type',
                id: componentId,
                details: form
            });
        } else {
            if (emptyComponentType.errors) {
                setErrorComponentType(emptyComponentType.errors);
            }
        }
    }

    const emptyStateInput = () => {
        setForm({
            componentType: "",
        });
        setComponentId('');
    };

    const emptyState = () => {
        setErrorComponentType(false);
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            loadTasks();
            handleClose();
            toast.dismiss();
            toast(createDetails);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorComponentType(error);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setErrorComponentType(error);
        }
    }, [editDetails, editError]);

    const onEdit = (data) => {
        setVisible(true);
        setComponentId(data.id);
        setForm({
            componentType: data.componentType
        });
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setComponentId(data.id);
        setComponentType(data.componentType);
    };

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const handleAddMore = (e) => {
        createComponent(e);
        setAddMore(true);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.COMPONENT_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'selfBill',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Younote Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Component Type', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Component Type'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Component Type', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image src={SearchIcon} preview={false} />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Component Type', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('Component Types'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Component Type', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Component Type', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Component Type</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Component Type', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`${componentId ? 'Edit' : 'Add'} Component Type`}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createComponent(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Component Type ", <span key={"Component Type"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorComponentType ? true : false}
                                    helperText={errorComponentType}
                                    name={"componentType"}
                                    value={form.componentType}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}
                                    >
                                        {
                                            componentId ? 'Update & Close' : 'Save & Close'
                                        }
                                    </Button>
                                    {
                                        !componentId && <Button
                                            key="add"
                                            onClick={(e) => handleAddMore(e)}
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        >
                                            Add more
                                        </Button>
                                    }

                                </Space>
                            </div>
                        </Box>
                    }
                />
                <DeleteModal onClose={(v) => handleDeleteModal(v)}
                    id={componentId} loadTasks={() => loadTasks()}
                    name={componentType} url={'component-types'} title={'Component Type'} visible={deleteModal} />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Component Types'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={componentDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}

export default ComponentType